import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/core/redux/store";
import { getSupplierResponsesAllThunk } from "@/core/redux/thunks/supplierResponsesAllThunk";
import TableRow from "./table-row/table-row";
import { LoadingState, ErrorState, EmptyState } from "./ui-states";
import { setStatus } from "@/core/redux/slices/supplier-responses-all";
import { useEmptyStateVariant } from "./use-empty-state-variant";
import { getDashboardLink } from "@/shared/utils/link";
import { setInitialSpecification } from "@/core/redux/slices/specification";
import { ROUTES } from "@/core/router/routes";
import { useNavigate } from "react-router-dom";

export default function TableBody() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, loading, error, pagination, search, status } = useSelector(
    (state: RootState) => state.supplierResponsesAll
  );
  const companyId = useSelector(
    (state: RootState) => state.user.me?.company?.id
  );

  const emptyStateVariant = useEmptyStateVariant({
    search,
    status,
  });

  const handleClearFilters = () => {
    if (status.length > 0) {
      dispatch(setStatus([]));
    }
  };

  useEffect(() => {
    if (companyId) {
      dispatch(
        getSupplierResponsesAllThunk({
          companyId,
          offset: pagination.offset,
          limit: pagination.limit,
        }) as any
      );
    }
  }, [companyId, dispatch]);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState error={error || "Bir hata oluştu"} />;
  if (!data || data.length === 0)
    return (
      <EmptyState
        onCreateSpecificationWithAi={() => {
          dispatch(setInitialSpecification());
          navigate(
            getDashboardLink(ROUTES.Dashboard.Specification.Create) + "?ai=true"
          );
        }}
        onImportSpecification={() => {}}
        onCollectResponses={() => {}}
        variant={emptyStateVariant}
        searchTerm={search?.trim() ?? ""}
        onClearFilters={status.length > 0 ? handleClearFilters : () => {}}
      />
    );

  return (
    <div className="w-full">
      {data.map((item) => (
        <TableRow key={item.specificationId} data={item} />
      ))}
    </div>
  );
}
